import { getAxisDrivenSlotColumns, isMeasureCol } from './helpers';
import { ChartFamily } from './types';
export var ChartType;
(function (ChartType) {
    ChartType["Pivot"] = "pivot";
    ChartType["Bar"] = "bar";
    ChartType["StackedBar"] = "stacked-bar";
    ChartType["Column"] = "column";
    ChartType["StackedColumn"] = "stacked-column";
    ChartType["Line"] = "line";
    ChartType["Area"] = "area";
    ChartType["StackedArea"] = "stacked-area";
    ChartType["LineColumn"] = "line-column";
    ChartType["LineStackedColumn"] = "line-stacked-column";
    ChartType["Pareto"] = "pareto";
    ChartType["Donut"] = "donut";
    ChartType["Scatter"] = "scatter";
    ChartType["Bubble"] = "bubble";
    ChartType["Heatmap"] = "heatmap";
})(ChartType || (ChartType = {}));
const SLOT_X_AXIS = 'x-axis';
const SLOT_Y_AXIS = 'y-axis';
const SLOT_PIVOT_ROWS = 'rows';
const SLOT_PIVOT_COLUMNS = 'columns';
const SLOT_SIZE = 'size';
const CARTESIAN_AXIS_ENCODINGS = Object.freeze({
    rows: SLOT_Y_AXIS,
    columns: SLOT_X_AXIS,
});
const PIVOT_AXIS_ENCODINGS = Object.freeze({
    rows: SLOT_PIVOT_ROWS,
    columns: SLOT_PIVOT_COLUMNS,
});
function pointChartNeedsMnMvPostProcessing(chartConfig) {
    const xHasMeasures = getAxisDrivenSlotColumns(chartConfig, SLOT_X_AXIS).some(isMeasureCol);
    const yHasMeasures = getAxisDrivenSlotColumns(chartConfig, SLOT_Y_AXIS).some(isMeasureCol);
    return (xHasMeasures && yHasMeasures) || (!xHasMeasures && !yHasMeasures);
}
function bubbleNeedsMnMvPostProcessing(chartConfig) {
    return (pointChartNeedsMnMvPostProcessing(chartConfig) ||
        getAxisDrivenSlotColumns(chartConfig, SLOT_SIZE).length > 0);
}
const CARTESIAN_TRAITS = {
    family: ChartFamily.Cartesian,
    axisEncodings: CARTESIAN_AXIS_ENCODINGS,
};
const CHART_TYPE_REGISTRY = {
    [ChartType.Pivot]: {
        family: ChartFamily.Pivot,
        axisEncodings: PIVOT_AXIS_ENCODINGS,
    },
    [ChartType.Bar]: CARTESIAN_TRAITS,
    [ChartType.StackedBar]: CARTESIAN_TRAITS,
    [ChartType.Column]: CARTESIAN_TRAITS,
    [ChartType.StackedColumn]: CARTESIAN_TRAITS,
    [ChartType.Line]: CARTESIAN_TRAITS,
    [ChartType.Area]: CARTESIAN_TRAITS,
    [ChartType.StackedArea]: CARTESIAN_TRAITS,
    [ChartType.LineColumn]: CARTESIAN_TRAITS,
    [ChartType.LineStackedColumn]: {
        family: ChartFamily.LineStackedColumn,
        axisEncodings: CARTESIAN_AXIS_ENCODINGS,
    },
    [ChartType.Pareto]: CARTESIAN_TRAITS,
    [ChartType.Donut]: {
        family: ChartFamily.Polar,
        axisEncodings: CARTESIAN_AXIS_ENCODINGS,
    },
    [ChartType.Scatter]: {
        family: ChartFamily.Cartesian,
        axisEncodings: CARTESIAN_AXIS_ENCODINGS,
        needsMnMvPostProcessing: pointChartNeedsMnMvPostProcessing,
    },
    [ChartType.Bubble]: {
        family: ChartFamily.Cartesian,
        axisEncodings: CARTESIAN_AXIS_ENCODINGS,
        needsMnMvPostProcessing: bubbleNeedsMnMvPostProcessing,
    },
    [ChartType.Heatmap]: {
        family: ChartFamily.Cartesian,
        axisEncodings: CARTESIAN_AXIS_ENCODINGS,
    },
};
function getTraits(chartType) {
    const traits = CHART_TYPE_REGISTRY[chartType];
    if (!traits) {
        throw new Error(`Chart type '${chartType}' is not in CHART_TYPE_REGISTRY — ` +
            'add its entry (see "Adding a new chart type" in chart-type.ts).');
    }
    return traits;
}
export function getChartFamilyForType(chartType) {
    return getTraits(chartType).family;
}
export function getAxisEncodingKeysForType(chartType) {
    return getTraits(chartType).axisEncodings;
}
export function needsMnMvPostProcessingForType(chartType, chartConfig) {
    return (CHART_TYPE_REGISTRY[chartType]?.needsMnMvPostProcessing?.(chartConfig) ?? false);
}
//# sourceMappingURL=chart-type.js.map